/**
 * Doc-type icon for the editor's DocumentStamp — the "file-lines" option
 * from Claude Design's doc-type icon set: a folded-corner document with
 * body lines, the set's neutral default. Inlined as a component so it
 * inherits the stamp's text colour via `stroke="currentColor"`.
 *
 * The set ships two other options (page-columns, article-heading) in the
 * design zip — swap the paths below to switch the read.
 */
export function DocTypeIcon({ size = 14 }: { size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.6}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M14 3v4a1 1 0 0 0 1 1h4" />
      <path d="M17 21H7a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h7l5 5v11a2 2 0 0 1-2 2z" />
      <line x1="8" y1="13" x2="15" y2="13" />
      <line x1="8" y1="16" x2="13" y2="16" />
    </svg>
  );
}
